import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {FieldDefinition} from '@shared/models/field-definition';
import {ArchiveReportCommand} from '../../commands/survey.commands';
import {takeUntil} from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'particle-report-contact-status-cell-viewer',
  templateUrl: './report-contact-status-cell-viewer.component.html',
  styleUrls: ['./report-contact-status-cell-viewer.component.scss']
})
export class ReportContactStatusCellViewerComponent implements OnInit {
  invalidateSubject?: InvalidateSubject;
  item: any;
  fieldDefinition: FieldDefinition;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();
  onClicked(action: string) {
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, action: {id: action}});
  }

  constructor() { }

  ngOnInit() {
  }
  getRequestCellStyle(){
    if(this.item.cells[this.fieldDefinition.key].value === 'Accepted'){
      return {
        color: '#2ebb54'
      };
    }
    else if(this.item.cells[this.fieldDefinition.key].value === 'Request Sent'){
      return {
        color: 'rgba(255, 172, 69, 1)'
      };
    }
  }

}
